import {useForm, zodResolver} from '@mantine/form';
import {useEffect} from 'react';
import {z} from 'zod';

type Props = {
  placeholder: string;
  setSearchWords: React.Dispatch<React.SetStateAction<string>>;
};

const SearchFormInput = z.object({
  q: z.string(),
});
type SearchFormInput = z.infer<typeof SearchFormInput>;

export const CommunitySearchForm: React.FC<Props> = ({
  placeholder,
  setSearchWords,
}) => {
  const form = useForm<SearchFormInput>({
    initialValues: {
      q: '',
    },
    validate: zodResolver(SearchFormInput),
  });

  const onSubmit = (input: SearchFormInput): {q: string} => {
    setSearchWords(input.q);

    return {
      q: input.q,
    };
  };

  const onError = () => {
    alert('エラーが発生しました');
  };

  useEffect(() => {
    if (form.values.q === '') {
      setSearchWords('');
    }
  }, [form.values.q]);

  return (
    <form onSubmit={form.onSubmit(onSubmit, onError)}>
      <input
        id="q"
        {...form.getInputProps('q')}
        placeholder={placeholder}
        className="border-[1px] border-line border-collapse p-8 w-full rounded-4 text-base"
        autoComplete="off"
        type="text"
      />
    </form>
  );
};
